.ei{padding:0.5rem;}